// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__AXdaa","visible":"styles_visible__EAvuI","container":"styles_container__hncMr","backLink":"styles_backLink__yVcmC"};